import { getTimeLeft, parseTimeLeftString } from "../api/utils";
import { Badge } from "../common/styles";
import { jsx as _jsx } from "react/jsx-runtime";
function RoundStartCountdownBadge(props) {
  const {
    targetDate
  } = props;
  const targetDateString = Math.round(targetDate.getTime() / 1000).toString();
  const timeLeft = getTimeLeft(targetDateString);
  const timeLeftString = parseTimeLeftString(timeLeft);
  const badgeString = `Donations start in ${timeLeftString}`;
  return /*#__PURE__*/_jsx(Badge, {
    color: "rainbow",
    rounded: "full",
    className: "flex-shrink-0 px-2.5 font-modern-era-bold",
    "data-testid": "donations-countdown-badge",
    children: badgeString
  });
}
export default RoundStartCountdownBadge;